import React, {
  PropsWithChildren,
  ReactNode,
  SVGProps,
  cloneElement,
  type HTMLAttributes,
} from "react";

export type BaseIconProps = {
  /** the size in pixels of the icon */
  size?: number;
  /** the CSS-compatible color to apply to the icon */
  color?: string;
  className?: HTMLAttributes<HTMLOrSVGElement>["className"];
  style?: HTMLAttributes<HTMLOrSVGElement>["style"];
  /** short description of the icon */
  alt?: string;
  /** longer description of the icon */
  "aria-roledescription"?: HTMLAttributes<HTMLOrSVGElement>["aria-roledescription"];
};

export type BaseSVGIconProps = BaseIconProps & SVGProps<SVGSVGElement>;

export const BaseIcon = ({
  children,
  size,
  color,
  ...restProps
}: PropsWithChildren<BaseIconProps>) => {
  if (React.isValidElement(children)) {
    const allProps = {
      ...restProps,
      width: size ?? 24,
      height: size ?? 24,
      color: color ?? "currentColor",
    };

    return cloneElement<ReactNode>(children, {
      ...allProps,
    });
  } else {
    return null;
  }
};
